import { notification, Spin } from 'antd';
import ArrowTurnLeft from 'assets/Images/arrow-turn-left';
import ArrowTurnRight from 'assets/Images/arrow-turn-right';
import { Conditional } from 'components/conditional/conditional';
import { useHeropenenModal } from 'components/indienen-heropenen/useHeropenenModal';
import { useIndienenModal } from 'components/indienen-heropenen/useIndienenModal';
import { getIndienenColor, getIndienenText } from 'helpers/menu-helpers';
import { FC } from 'react';
import styles from './main-menu.module.scss';
import { useCallContext } from 'helpers/hooks/use-context';

interface IndienenMenuItemProps {
  isDisabled?: boolean;
  isPilot?: boolean;
  isDemo?: boolean;
  kringloopwijzerStatusId: number;
}

export const IndienenMenuItem: FC<IndienenMenuItemProps> = ({ isDisabled, isPilot, isDemo, kringloopwijzerStatusId }) => {
  const { indienenModal, isPending: indienenPending, openModal: openIndienen } = useIndienenModal();
  const { heropenenModal, isPending: heropenenPending, openModal: openHeropenen } = useHeropenenModal();
  const callContext = useCallContext();
  const disabled = [isDisabled, isDemo, isPilot, callContext?.data?.gebruikerIsSBMedewerker].find(f => f === true);

  return (
    <Spin spinning={indienenPending || heropenenPending}>
      <div
        className={styles.hover}
        onClick={() => {
          if (callContext?.data?.gebruikerIsSBMedewerker) {
            notification.info({ message: 'Het is niet mogelijk deze KringloopWijzer in te dienen als supportmedewerker.' });
            return;
          }
          if (!callContext?.data?.gebruikerIsDeelnemer && !callContext?.data?.volmacht && !callContext?.data?.gebruikerIsAuthorized) {
            notification.info({ message: 'Het is niet mogelijk deze KringloopWijzer in te dienen zonder schrijfrechten' });
            return;
          }
          if (isDemo) {
            notification.info({ message: 'Het is niet mogelijk deze KringloopWijzer in te dienen omdat dit een demo is.' });
            return;
          }
          if (isPilot) {
            notification.info({ message: 'Het is niet mogelijk deze KringloopWijzer in te dienen omdat dit een pilot is.' });
            return;
          }
          if (isDisabled) {
            notification.info({ message: 'Het is niet mogelijk deze KringloopWijzer in te dienen omdat deze nog niet volledig is ingevuld.' });
            return;
          }
          if (kringloopwijzerStatusId === 1) {
            openIndienen();
            return;
          }
          if (kringloopwijzerStatusId === 2) {
            openHeropenen();
            return;
          }
          if (kringloopwijzerStatusId === 3) {
            notification.info({ message: 'Deze KringloopWijzer is definitief en kan niet meer worden gewijzigd.' });
            return;
          }
          if (kringloopwijzerStatusId === 4) {
            notification.info({ message: 'Deze KringloopWijzer is afgekeurd en kan niet meer worden gewijzigd.' });
            return;
          }
        }}>
        <span className={styles.flexButton}>
          <span className={styles.title} style={{ color: getIndienenColor(kringloopwijzerStatusId, disabled) }}>
            {getIndienenText(kringloopwijzerStatusId)}
          </span>
          <Conditional condition={kringloopwijzerStatusId === 1}>
            <ArrowTurnRight style={{ height: 40, marginBottom: '14px' }} color={getIndienenColor(kringloopwijzerStatusId, disabled)} />
          </Conditional>
          <Conditional condition={[2, 3, 4].includes(kringloopwijzerStatusId)}>
            <ArrowTurnLeft style={{ height: 40, marginBottom: '14px' }} color={getIndienenColor(kringloopwijzerStatusId, disabled)} />
          </Conditional>
          {indienenModal}
          {heropenenModal}
        </span>
      </div>
    </Spin>
  );
};
